import { useSelector } from 'react-redux';

export function useIsLogged(): boolean {
   const { isLogged } = useSelector<any>((store: any) => store.auth) as any;
   const user = useSelector<any>((store: any) => store.user) as any;

   return isLogged && user;
}
